import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IconChevronDown } from '@tabler/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import EntityMessagesDetails from 'src/components/reservations/new-reservations/hotel/hotel-details/hotel-room-details/hotel-room-type-item-details/EntityMessagesDetails';
import ChildCard from 'src/components/shared/ChildCard';
import FallbackTypography from 'src/components/shared/FallbackTypography';
import { getRoomMessages, getUniqueMessages } from 'src/utils/hotelMessageUtils';

const ViewHotelReservationInfo = ({ item }) => {
    const { reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
    const hotel = reservationOverview?.Hotels?.find(h => h.ItemReference === item.ItemReference);

    return (
        <Grid container justifyContent="center" p={2}>
            {hotel?.Rooms?.length > 0 ? (
                <>
                    <Grid container size={{ xs: 12 }} px={4} justifyContent="space-between" >
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Room Name</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Room Type</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Room Count</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Discount</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Description</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Supplements</Typography>
                        </Grid>
                    </Grid>

                    {/* Room Details */}
                    {hotel.Rooms.map((room, index) => {
                        const roomMessages = getUniqueMessages(getRoomMessages(room, hotel));
                        
                        return (
                            <ChildCard key={`room-${hotel.ItemReference}-${index}`}>
                                <Grid container spacing={2} justifyContent="space-between" mx={0}>
                                    {/* Room Name */}
                                    <Grid size={{ xs: 2 }} lg={2}>
                                        <FallbackTypography variant="body2" value={room.RoomName} />
                                    </Grid>
                                    {/* Room Type */}
                                    <Grid size={{ xs: 2 }} lg={2}>
                                        <FallbackTypography variant="body2" value={room.RoomType} />
                                    </Grid>
                                    {/* Room Count */}
                                    <Grid size={{ xs: 2 }} sm={2} lg={2}>
                                        <FallbackTypography variant="body2" value={room.UnitCount} />
                                    </Grid>
                                    {/* Discount */}
                                    <Grid size={{ xs: 2 }} sm={2} lg={2}>
                                        {room?.Discounts?.length > 0 ? (
                                            room.Discounts.map((d, idx) => (
                                                <FallbackTypography key={`discount-${idx}`} variant="body2" value={d.Name} />
                                            ))
                                        ) : (
                                            <FallbackTypography variant="body2" value={null} />
                                        )}
                                    </Grid>
                                    {/* Description */}
                                    <Grid size={{ xs: 2, md: 2 }} lg={3}>
                                        {room?.Discounts?.length > 0 ? (
                                            room.Discounts.map((d, idx) => (
                                                <FallbackTypography key={`desc-${idx}`} variant="body2" value={d.Description} />
                                            ))
                                        ) : (
                                            <FallbackTypography variant="body2" value={null} />
                                        )}
                                    </Grid>
                                    {/* Supplements */}
                                    <Grid size={{ xs: 2 }} lg={1}>
                                        {room?.Supplements?.length > 0 ? (
                                            room.Supplements.map((s, idx) => (
                                                <FallbackTypography key={`supp-${idx}`} variant="body2" value={s.Name} />
                                            ))
                                        ) : (
                                            <FallbackTypography variant="body2" value={null} />
                                        )}
                                    </Grid>
                                </Grid>

                                {/* Hotel Messages for Each Room */}
                                {roomMessages.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<IconChevronDown />}
                                            aria-controls={`panel-${index}-content`}
                                            id={`panel-${index}-header`}
                                        >
                                            <Typography variant="body2" fontWeight="bold">
                                                Room Messages
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <EntityMessagesDetails
                                                messages={roomMessages} 
                                                overviewScreen={true} 
                                            />
                                        </AccordionDetails>
                                    </Accordion>
                                )}
                            </ChildCard>
                        );
                    })}
                </>
            ) : (
                <Grid item xs={12}>
                    <Typography variant="body2">No rooms selected.</Typography>
                </Grid>
            )}
        </Grid>
    );
};

export default ViewHotelReservationInfo;